module.exports = __webpack_public_path__ + "static/media/sample.50c5a5a7.jpg";